import React, { useEffect, useState } from "react";
import { getSites } from "../../services/sites";
import { errorMessage } from "../../services";
import Loader from "../../components/Loader";
import ManageOrders from "../ManageOrders";

const SAVED_KEY = "ownezzy_orders_site"; // the website last picked, opened again next time

const savedSite = () => {
  try { return localStorage.getItem(SAVED_KEY) || ""; } catch { return ""; }
};

// Store owners' "Order management" tab: a website picker on top (the first website, or the one picked last time),
// and that website's orders below. Each website shows its pending orders beside its name.
export default function OrdersTab({ setTab }) {
  const [sites, setSites] = useState(null); // null while loading
  const [error, setError] = useState("");
  const [siteId, setSiteId] = useState("");

  useEffect(() => {
    let live = true;
    getSites({ limit: 100, sort: "oldest" })
      .then(({ data }) => {
        if (!live) return;
        setSites(data.sites);
        const saved = savedSite();
        setSiteId(data.sites.some((s) => s.id === saved) ? saved : (data.sites[0] || {}).id || "");
      })
      .catch((err) => live && (setSites([]), setError(errorMessage(err))));
    return () => { live = false; };
  }, []);

  const pick = (id) => {
    setSiteId(id);
    try { localStorage.setItem(SAVED_KEY, id); } catch { /* remembered for this visit only */ }
  };

  if (sites === null) return <Loader label="Loading your websites" />;
  if (!sites.length) {
    return (
      <section className="panel orders-empty">
        {error ? <div className="admin-error">{error}</div> : <p>You have no websites yet. Your orders show here once you have one.</p>}
        <button className="primary-btn" onClick={() => setTab("My websites")}>Go to My websites</button>
      </section>
    );
  }

  const picker = (
    <label className="orders-site-picker">
      <span>Website</span>
      <select value={siteId} onChange={(e) => pick(e.target.value)} aria-label="Choose a website">
        {sites.map((s) => (
          <option key={s.id} value={s.id}>{s.name}{s.pendingOrders ? ` (${s.pendingOrders} pending)` : ""}</option>
        ))}
      </select>
    </label>
  );
  return <ManageOrders key={siteId} siteId={siteId} embedded sitePicker={picker} />;
}
